import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { OrganisationApi, CheckInInterface, OrganisationsApi } from '@careapp/angular-sdk';
import { CheckIns } from '../actions/check-ins.actions';
import { Customers } from '../actions/customers.actions';
import { switchMap, map, withLatestFrom, catchError, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as selectors from '../reducers/index';
import { of } from 'rxjs';

@Injectable()
export class CheckInsEffects {
  @Effect()
  fetchAll = this.actions$.ofType(CheckIns.REQUEST_ALL).pipe(
    withLatestFrom(
      this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS)),
      this.store.select(selectors.statistics.getFilters)
    ),
    switchMap(([action, org, filters]) => {
      return this.api
        .listCheckIns(org, {
          where: {
            created: {
              between: [filters.dateFrom.toISOString(), filters.dateTo.toISOString()]
            }
          }
        })
        .pipe(
          map(res => CheckIns.ResponseSuccessAllAction(res)),
          catchError(err => of(CheckIns.ResponseFailAllAction(err)))
        );
    })
  );

  @Effect({ dispatch: false })
  fetchRelatedCustomers = this.actions$.ofType(CheckIns.RESPONSE_SUCCESS_ALL).pipe(
    tap(action => {
      let distinct = Array.from(new Set((<any>action).payload.map(checkIn => checkIn.customerId)));
      distinct.map((customerId: string) => {
        this.store.dispatch(Customers.RequestByIdAction({ id: customerId }));
      });
    })
  );

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private api: OrganisationsApi
  ) {}
}
